/* Seace Bloom theme — storefront behaviour (cart drawer, product page, filters). */
(function () {
  const T = window.theme || {};
  const S = T.strings || {};
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];

  /* ---------- helpers ---------- */
  const toast = $('#Toast');
  let toastTimer;
  function say(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('show'), 2200);
  }
  function formatMoney(cents) {
    const fmt = T.moneyFormat || '{{amount}}';
    const value = (cents / 100);
    const withDelims = (n, d) => {
      const [i, f] = n.toFixed(d).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (f ? '.' + f : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0);
        case 'amount_with_comma_separator': return withDelims(value, 2).replace(/,/g, '.').replace(/\.(\d\d)$/, ',$1');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0).replace(/,/g, '.');
        default: return withDelims(value, 2);
      }
    });
  }
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  // locale strings use [name] placeholders, e.g. "Add [amount] more"
  const tpl = (str, vars) => String(str || '').replace(/\[(\w+)\]/g, (_, k) => vars[k] ?? '');

  /* ---------- cart ---------- */
  const drawer = $('#CartDrawer');
  async function getCart() {
    const r = await fetch(T.routes.cartJs, { headers: { Accept: 'application/json' } });
    return r.json();
  }
  function shipCell(cart) {
    const at = T.freeShippingAt || 0;
    if (at && cart.total_price >= at) return `<span>${S.free}</span>`;
    if (T.shippingPrice) return `<span>${formatMoney(T.shippingPrice)}</span>`;
    return `<span class="muted">${S.shippingAtCheckout}</span>`;
  }
  function shipBar(cart) {
    const at = T.freeShippingAt || 0;
    if (!at || !cart.item_count) return '';
    const total = cart.total_price;
    const pct = Math.min(100, (total / at) * 100);
    const msg = total >= at ? S.gotFree : tpl(S.leftForFree, { amount: '<b>' + formatMoney(at - total) + '</b>' });
    return `<span>${msg}</span><div class="meter"><i style="width:${pct}%"></i></div>`;
  }
  function lineHTML(item) {
    const img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') : '';
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<small>${esc(item.variant_title)}</small>` : '';
    return `<div class="line-item">
      ${img ? `<img src="${img}${img.includes('?') ? '&' : '?'}width=160" alt="" loading="lazy">` : '<span></span>'}
      <div class="nm"><b>${esc(item.product_title)}</b>${variant}
        <span class="mini-qty"><button type="button" data-line-change="${item.key}" data-qty="${item.quantity - 1}" aria-label="-">−</button><span>${item.quantity}</span><button type="button" data-line-change="${item.key}" data-qty="${item.quantity + 1}" aria-label="+">+</button></span>
      </div>
      <div class="end"><span>${formatMoney(item.final_line_price)}</span><button type="button" class="rm" data-line-change="${item.key}" data-qty="0">${S.remove}</button></div>
    </div>`;
  }
  function renderCart(cart) {
    $$('[data-cart-count]').forEach((el) => {
      if (el.textContent !== String(cart.item_count)) { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
      el.textContent = cart.item_count;
    });
    if (!drawer) return;
    const list = $('#CartDrawerList'), foot = $('#CartDrawerFoot'), ship = $('#CartDrawerShip');
    if (!cart.item_count) {
      list.innerHTML = `<div class="empty"><b>${S.empty}</b><span>${S.emptySub}</span><a class="btn btn-primary" href="/collections/all">${S.shopNow}</a></div>`;
      foot.hidden = true; ship.hidden = true;
      return;
    }
    list.innerHTML = cart.items.map(lineHTML).join('');
    ship.innerHTML = shipBar(cart); ship.hidden = !ship.innerHTML;
    foot.hidden = false;
    foot.innerHTML = `<div class="row"><span>${S.subtotal}</span><b>${formatMoney(cart.total_price)}</b></div>
      <div class="row"><span>${S.shipping}</span>${shipCell(cart)}</div>
      <a class="btn btn-primary btn-block" href="/checkout">${S.checkout}</a>
      <a class="btn btn-line btn-block" href="${T.routes.cart}">${S.viewCart}</a>`;
  }
  async function openCart() {
    if (!drawer) { location.href = T.routes.cart; return; }
    renderCart(await getCart());
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    const c = $('[data-cart-close]', drawer); if (c) c.focus();
  }
  function closeCart() { if (drawer) { drawer.hidden = true; document.body.style.overflow = ''; } }
  async function addToCart(id, quantity = 1) {
    const r = await fetch(T.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) }] })
    });
    if (!r.ok) {
      const e = await r.json().catch(() => ({}));
      throw new Error(e.description || S.error);
    }
    return r.json();
  }
  async function changeLine(key, quantity) {
    const r = await fetch(T.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Number(quantity) })
    });
    return r.json();
  }

  document.addEventListener('click', async (e) => {
    const opener = e.target.closest('[data-cart-open]');
    if (opener && drawer && !document.body.classList.contains('template-cart')) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-cart-close]') || e.target === drawer) { closeCart(); return; }

    const add = e.target.closest('[data-add]');
    if (add) {
      add.disabled = true;
      try { await addToCart(add.dataset.add, 1); say(S.added); await openCart(); }
      catch (err) { say(err.message); }
      finally { add.disabled = false; }
      return;
    }
    const ch = e.target.closest('[data-line-change]');
    if (ch) {
      ch.disabled = true;
      renderCart(await changeLine(ch.dataset.lineChange, Math.max(0, +ch.dataset.qty)));
      return;
    }
    const copy = e.target.closest('[data-copy]');
    if (copy) {
      const text = copy.dataset.copy;
      if (navigator.clipboard) navigator.clipboard.writeText(text).then(() => say(S.copied)).catch(() => {});
    }
  });

  /* ---------- language: follow the phone's language on the first visit ---------- */
  const LANG_KEY = 'sb-lang-chosen';
  document.addEventListener('click', (e) => {
    if (e.isTrusted && e.target.closest('.lang-form .lang')) { try { localStorage.setItem(LANG_KEY, '1'); } catch (_) {} }
  });
  (function autoLang() {
    try {
      if (!window.matchMedia('(max-width: 900px)').matches) return;
      if (navigator.webdriver || /bot|crawl|spider|slurp|lighthouse|preview/i.test(navigator.userAgent)) return;
      if (localStorage.getItem(LANG_KEY) || sessionStorage.getItem('sb-lang-auto')) return;
      sessionStorage.setItem('sb-lang-auto', '1');
      const btn = $('.lang-form .lang');
      if (!btn) return;
      const cur = (document.documentElement.lang || '').slice(0, 2).toLowerCase();
      const other = (btn.value || '').slice(0, 2).toLowerCase();
      const prefs = (navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || ''])
        .map((l) => String(l).slice(0, 2).toLowerCase());
      const pick = prefs.find((l) => l === cur || l === other);
      if (pick && pick !== cur) btn.form.requestSubmit ? btn.form.requestSubmit(btn) : btn.click();
    } catch (_) {}
  })();

  /* ---------- ingredient drops: bounce on tap; in the product tab, show only the tapped one's details ---------- */
  function tapIngredient(item) {
    item.classList.remove('pop');
    void item.offsetWidth;
    item.classList.add('pop');
    item.addEventListener('animationend', () => item.classList.remove('pop'), { once: true });

    const grid = item.closest('.ing-pdp');
    if (!grid) return;
    const panel = $('.ing-detail', grid) || (grid.nextElementSibling && grid.nextElementSibling.classList.contains('ing-detail') ? grid.nextElementSibling : null);
    if (!panel) return;
    // open the panel right under the tapped drop's row
    const row = $$(':scope > div[role="button"]', grid).filter((el) => el.offsetTop === item.offsetTop);
    row[row.length - 1].after(panel);
    const wasOpen = item.classList.contains('is-on');
    $$('.is-on', grid).forEach((el) => { el.classList.remove('is-on'); el.setAttribute('aria-expanded', 'false'); });
    if (wasOpen) { panel.hidden = true; return; }
    item.classList.add('is-on');
    item.setAttribute('aria-expanded', 'true');
    const name = item.querySelector('h3');
    const text = item.querySelector('p');
    panel.style.setProperty('--c', item.style.getPropertyValue('--c'));
    panel.innerHTML = '<b></b><span></span>';
    panel.querySelector('b').textContent = name ? name.textContent : '';
    panel.querySelector('span').textContent = text ? text.textContent : '';
    panel.hidden = false;
  }
  document.addEventListener('click', (e) => {
    const item = e.target.closest('.ing > div');
    if (item && !item.classList.contains('ing-detail')) tapIngredient(item);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const item = e.target.closest && e.target.closest('.ing-pdp > div');
    if (!item) return;
    e.preventDefault();
    tapIngredient(item);
  });

  /* ---------- mobile menu ---------- */
  const menu = $('#MobileMenu');
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-menu-open]') && menu) { menu.hidden = false; return; }
    if (menu && (e.target.closest('[data-menu-close]') || e.target === menu)) menu.hidden = true;
  });

  /* ---------- product page ---------- */
  const pform = $('[data-product-form]');
  if (pform) {
    const qOut = $('[data-qty-input]', pform);
    const priceEl = $('[data-price]');
    const compareEl = $('[data-compare]');
    const stickyPrice = $('[data-sticky-price]');
    const unitPrice = () => {
      const r = $('input[name="id"]:checked', pform) || $('input[name="id"]', pform);
      return r ? { price: +r.dataset.price, compare: +r.dataset.compare || 0, available: r.dataset.available !== 'false' } : null;
    };
    const update = () => {
      const u = unitPrice(); if (!u) return;
      const q = Math.max(1, +qOut.value || 1);
      if (priceEl) priceEl.textContent = formatMoney(u.price * q);
      if (compareEl) { compareEl.textContent = u.compare > u.price ? formatMoney(u.compare * q) : ''; compareEl.hidden = !(u.compare > u.price); }
      const offEl = $('.pdp-price .off');
      if (offEl) {
        const pct = u.compare > u.price ? Math.floor(((u.compare - u.price) * 100) / u.compare) : 0;
        offEl.textContent = offEl.textContent.replace(/[0-9٠-٩]+/, pct);
        offEl.hidden = !pct;
      }
      if (stickyPrice) stickyPrice.textContent = formatMoney(u.price * q);
      $$('[data-submit]').forEach((b) => (b.disabled = !u.available));
    };
    $$('input[name="id"]', pform).forEach((r) => r.addEventListener('change', () => {
      update();
      const mediaId = r.dataset.media;
      if (mediaId) { const t = $(`[data-thumb][data-media="${mediaId}"]`); if (t) t.click(); }
      const url = new URL(location.href); url.searchParams.set('variant', r.value); history.replaceState({}, '', url);
    }));
    $$('[data-qty-step]', pform).forEach((b) => b.addEventListener('click', () => {
      qOut.value = Math.min(20, Math.max(1, (+qOut.value || 1) + +b.dataset.qtyStep)); update();
    }));
    pform.addEventListener('submit', async (e) => {
      e.preventDefault();
      const buyNow = e.submitter && e.submitter.hasAttribute('data-buy-now');
      const r = $('input[name="id"]:checked', pform) || $('input[name="id"]', pform);
      $$('[data-submit]').forEach((b) => (b.disabled = true));
      try {
        await addToCart(r.value, qOut.value);
        if (buyNow) { location.href = '/checkout'; return; }
        say(S.added); await openCart();
      } catch (err) { say(err.message); }
      finally { update(); }
    });
    $$('[data-sticky-add]').forEach((b) => b.addEventListener('click', () => pform.requestSubmit()));
    update();

    // sticky buy bar on phones
    const sticky = $('[data-sticky-buy]'), anchor = $('[data-submit]', pform);
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => sticky.classList.toggle('show', !en.isIntersecting)).observe(anchor);
    }
  }

  /* gallery + lightbox */
  const stage = $('.stage-img');
  const thumbs = $$('[data-thumb]');
  const lb = $('#Lightbox');
  let gi = Math.max(0, thumbs.findIndex((t) => t.getAttribute('aria-current') === 'true'));
  function showImg(i) {
    if (!thumbs.length) return;
    gi = (i + thumbs.length) % thumbs.length;
    thumbs.forEach((t, j) => t.setAttribute('aria-current', j === gi));
    const src = thumbs[gi].dataset.src;
    if (stage) { stage.style.opacity = 0; setTimeout(() => { stage.src = src; stage.removeAttribute('srcset'); stage.style.opacity = 1; }, 150); }
    if (lb) { $('#LightboxImg').src = thumbs[gi].dataset.full || src; $('#LightboxCount').textContent = `${gi + 1} / ${thumbs.length}`; }
  }
  thumbs.forEach((t, i) => t.addEventListener('click', () => showImg(i)));
  if (lb) {
    const zoom = $('[data-zoom]');
    if (zoom) zoom.addEventListener('click', () => { showImg(gi); lb.hidden = false; });
    $('[data-lb-close]', lb).addEventListener('click', () => (lb.hidden = true));
    $('[data-lb-next]', lb).addEventListener('click', () => showImg(gi + 1));
    $('[data-lb-prev]', lb).addEventListener('click', () => showImg(gi - 1));
    lb.addEventListener('click', (e) => { if (e.target === lb) lb.hidden = true; });
  }
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { if (lb) lb.hidden = true; closeCart(); if (menu) menu.hidden = true; }
    if (lb && !lb.hidden && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) {
      const rtl = document.documentElement.dir === 'rtl';
      showImg(gi + (((e.key === 'ArrowLeft') === rtl) ? 1 : -1));
    }
  });

  /* ---------- scroll reveal ---------- */
  // Marks sections and grids for a fade-up when they scroll into view.
  if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    $$('main .sec-head, main .story, main .faq, main .news, main .who, main .about-cta').forEach((el) => el.setAttribute('data-reveal', ''));
    $$('main .grid, main .bgrid, main .ing, main .steps, main .trust, main .feats, main .ccards').forEach((el) => el.setAttribute('data-reveal-stagger', ''));
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    const pending = $$('[data-reveal], [data-reveal-stagger]');
    pending.forEach((el) => io.observe(el));
    // Safety net: also reveal by position on scroll, and reveal everything after 6s, so nothing stays hidden.
    let ticking = false;
    const check = () => {
      ticking = false;
      const limit = innerHeight * 0.95;
      pending.forEach((el) => { if (!el.classList.contains('in') && el.getBoundingClientRect().top < limit) el.classList.add('in'); });
    };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
    setTimeout(() => pending.forEach((el) => el.classList.add('in')), 6000);
    document.documentElement.classList.add('js-motion');
    check();
  }

  /* ---------- one tab open at a time ---------- */
  // Product tabs share a group: opening one closes the others (backup for browsers without <details name>).
  document.addEventListener('toggle', (e) => {
    const d = e.target;
    if (!(d instanceof HTMLDetailsElement) || !d.open || !d.dataset.tabGroup) return;
    $$('details[data-tab-group="' + d.dataset.tabGroup + '"]').forEach((o) => { if (o !== d && o.open) o.open = false; });
  }, true);

  /* ---------- collection filter chips ---------- */
  const chips = $$('[data-filter]');
  if (chips.length) {
    const cards = $$('[data-filter-grid] .card');
    const countEl = $('[data-filter-count]');
    const apply = (f) => {
      chips.forEach((c) => c.setAttribute('aria-pressed', c.dataset.filter === f));
      let n = 0;
      cards.forEach((c) => { const show = (c.dataset.k || '').split(' ').includes(f); c.hidden = !show; if (show) n++; });
      $$('[data-filter-group]').forEach((g) => { g.hidden = !g.querySelector('.card:not([hidden])'); });
      if (countEl) countEl.textContent = tpl(countEl.dataset.template, { count: n });
    };
    chips.forEach((c) => c.addEventListener('click', () => apply(c.dataset.filter)));
    apply('all');
  }
})();
